<template>
  <section>
    <div class="container">
      <div>
        <img v-if="image" class="title_box" :src="require(`@/assets/images/${image}`)"/>
      </div>

      <div class="container2">
        <div class="text1">{{ record ? record.text1 : "" }}</div>
        <div class="text2">{{ record ? record.text2 : "" }}</div>
      </div>
    </div>
  </section>
</template>
  
  <script>
import Caption from "./Caption.vue";
export default {
  props: ["record", "image"],
  components: {
    Caption,
  },
  data() {
    return {};
  },
};
</script>
  
<style scoped>
.container {
  display: flex;
  align-items: center;
}
.container2 {
  display: inline-block;
  text-align: left;
  margin-left: 20px;
  width: 312px;
  max-width: 312px;
}

.title_box {
  width: 88px;
}

.text1 {
  font-weight: 700;
  font-size: 18px;
  color: #000000;
}

.text2 {
  margin-top: 5px;
  font-weight: 300;
  font-size: 14px;
  color: #495057;
}

@media screen and (max-width: 1440px) {
  .container {
    display: flex;
    align-items: center;
    padding: 0px 0px 0px 20px;
  }
  .container2 {
    display: inline-block;
    text-align: left;
    margin-left: 20px;
    width: 100%;
  }

  .title_box {
    width: 88px;
  }

  .text1 {
    font-weight: 700;
    font-size: 18px;
    color: #000000;
  }

  .text2 {
    margin-top: 5px;
    font-weight: 300;
    font-size: 14px;
    color: #495057;
  }
}
</style>
  